import React from 'react';

const TIPO_MAP = {
  RECEITA: 'text-[#10B981]',
  DESPESA: 'text-[#EF4444]',
  CUSTO: 'text-[#D97706]',
};

const STATUS_MAP = {
  pago: 'text-[#10B981]',
  recebido: 'text-[#10B981]',
  pendente: 'text-[#6366F1]',
  atrasado: 'text-[#EF4444]',
  inadimplente: 'text-[#EF4444]',
  ativo: 'text-[#10B981]',
  suspenso: 'text-[#EF4444]',
};

const TAREFA_STATUS_MAP = {
  pendente: 'text-[#D97706]',
  'em andamento': 'text-[#6366F1]',
  concluída: 'text-[#10B981]',
  atrasada: 'text-[#EF4444]',
};

const PRIORIDADE_MAP = {
  alta: 'text-[#EF4444]',
  média: 'text-[#D97706]',
  baixa: 'text-[#10B981]',
};

export default function StatusBadge({ type, value, muted = false }) {
  const map = type === 'tipo' ? TIPO_MAP : type === 'tarefa' ? TAREFA_STATUS_MAP : type === 'prioridade' ? PRIORIDADE_MAP : STATUS_MAP;
  const cls = muted ? 'text-slate-500' : (map[value] || 'text-slate-600');

  return (
    <span
      className={`inline-flex items-center text-[11px] font-bold capitalize tracking-tight ${cls}`}
      data-testid={`badge-${type}-${value}`}
    >
      {value}
    </span>
  );
}
